<template>
  <section>
    <div v-show="!loader" v-if="profile" class="p-r p-l p-x-n">
      <!-- HEADER -->
      <company-header ref="cHeader" :profile="profile" v-if="profile.corporateProfile"></company-header>
      <!-- NAVBAR -->
      <div class="row hidden-lg hidden-md hidden-sm m-n">
        <div class="col-xs-12 no-padder">
          <div class="text-center bg-transparent">
            <user-nav :isVertical="false"></user-nav>
          </div>
        </div>
      </div>
      <error-page v-if="!profile.corporateProfile"></error-page>
      <!-- CONTENT -->
      <router-view class="router-view" :profile="profile" v-if="profile.corporateProfile"></router-view>
    </div>
    <div v-if="loader">
      <pre-loader></pre-loader>
    </div>
  </section>
</template>

<script>
import ApiService from "../../../services/ApiService";
import companyHeader from "../components/header/header.vue";
import userNav from "../components/header/navbar.vue";
import errorPage from "../../action/error";
import store from "../../../store";

export default {
  components: {
    companyHeader,
    userNav,
    errorPage
  },
  data() {
    return {
      loader: true,
      apiService: new ApiService(),
      accountService: new ApiService(
        process.env.ACCOUNT_URL,
        window.user.oauth_token
      )
    };
  },
  created() {
    this.getProfile();
    this.getRelatedCompanies();
    this.getProfileTypes();
    this.getProfileIndustries();
    this.getCountries();
  },
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.getProfile(to.params.id);
      this.getRelatedCompanies(to.params.id);
    }
    next();
  },
  methods: {
    getProfile(profileId = null) {
      this.loader = true;
      profileId = profileId ? profileId : this.$route.params.id;
      if (!profileId) return;
      this.accountService.get(`/api/profiles/` + profileId).then(res => {
        this.$store.dispatch("setProfile", res.data);
        this.loader=false
      });
    },
    getProfileTypes() {
      this.apiService.get(`common/company-type`).then(res => {
        this.$store.dispatch("setProfileTypes", res.items);
      });
    },
    getProfileIndustries() {
      this.apiService.get(`common/industry?per-page=300`).then(res => {
        this.$store.dispatch("setProfileIndustries", res.items);
      });
    },
    getCountries() {
      this.accountService.get(`/api/countries`).then(res => {
        this.$store.dispatch("setCountries", res.data);
      });
    },
    getRelatedCompanies(profileId = null) {
      profileId = profileId ? profileId : this.$route.params.id;
      this.apiService
        .get(
          `/corporate/related-companies?id=${profileId}&community=${window.user.community_id}&per-page=6`
        )
        .then(res => {
          this.$store.dispatch("setRelatedCompanies", res.items);
        });
    }
  },
  watch: {
    profile: to => {
      this.profile = to;
    }
  },

  computed: {
    profile() {
      return store.getters.profile;
    },
    cHeader() {
      return this.$refs.cHeader;
    }
  }
};
</script>

<style lang="scss">
@import "~@styles/common.scss";
@import "~@styles/company-view.scss";

@media only screen and (max-width: 767px) {
  .p-x-n {
    padding: 0px;
  }
}

.router-view {
  width: 100%;
}
.lazy-image-placeholder {
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto;
}
.lazy-img,
.lazy-image-main {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  width: 200px;
  height: 100px;
  left: calc(50% - 100px);
}
</style>
